import React, { useContext, useEffect, useState } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { Formik } from 'formik'
import { useHistory } from 'react-router-dom'
import { Card, CardBody, CardFooter, CardTitle, Button, Form } from 'reactstrap'
import {
  convertFromHTML,
  ContentState,
  EditorState,
  convertToRaw,
} from 'draft-js'
import draftToHtml from 'draftjs-to-html'

import MainContainer from '../../components/modules/containers/MainContainer'
import VisitForm from '../../components/home/VisitForm'
import { getAll } from '../../api/township'
import { getMembers } from '../../api/member'
import { editVisit } from '../../api/visit'
import UserContext from './../../store/userContext'
import VisitContext from './../../store/visitContext'
import { validateVisit } from '../../validations/visit'
import { patientHome } from '../../breadcrumRoutes.js'

const EditVisit = () => {
  const { id } = useParams()
  const [townships, setTownships] = useState([])
  const [members, setMember] = useState([])
  const [loading, setLoading] = useState(false)
  const [attachment, setAttachment] = useState(null)
  const [tableData, setTableData] = useState([])
  const [row, setRow] = useState()
  const [col, setCol] = useState()
  const [initValue, setInitValue] = useState({
    date: '',
    township_ids: [],
    co_visitors: [],
    type_of_visit: '',
    place_of_visit: '',
    tableData: '',
    attachment: '',
    coordination: '',
    program: '',
    m_and_e: '',
    recommendation: '',
  })
  const { project } = useParams()
  let location = useLocation()
  let history = useHistory()
  let { eachData } = useContext(UserContext)
  const { getEachData } = useContext(VisitContext)

  const converttoHtml = (value) => {
    if (typeof value === 'object') {
      const rawContentState = convertToRaw(value.getCurrentContent())
      const markup = draftToHtml(rawContentState)
      return markup
    } else {
      return value
    }
  }

  const submitData = async (values) => {
    values.id = id
    values.tableData = JSON.stringify(tableData)
    values.recommendation = converttoHtml(values.recommendation)
    values.m_and_e = converttoHtml(values.m_and_e)
    values.program = converttoHtml(values.program)
    values.coordination = converttoHtml(values.coordination)

    if (await editVisit(values, { name: 'attachment', file: attachment })) {
      history.push('/home')
    }
  }

  const getDraft = (sampleMarkup) => {
    const blocksFromHTML = convertFromHTML(sampleMarkup ? sampleMarkup : '')
    const state = ContentState.createFromBlockArray(
      blocksFromHTML.contentBlocks,
      blocksFromHTML.entityMap
    )
    return EditorState.createWithContent(state)
  }

  useEffect(() => {
    async function fetchMyAPI() {
      setLoading(true)
      let visitData = await getEachData({ column: 'id', value: id })

      let params = {}
      if (visitData.project === 'REGION') {
        params.region_id = visitData.region_id
      } else {
        params.project = visitData.project
      }
      let responseTownship = await getAll(params)
      setTownships(responseTownship)
      let responseMember = await getMembers()
      setMember(responseMember)

      setInitValue({
        date: visitData.date,
        township_ids: visitData.townships.map((e) => e.id),
        co_visitors: visitData.co_visitors.map((e) => e.id),
        type_of_visit: visitData.type_of_visit,
        place_of_visit: visitData.place_of_visit,
        coordination: getDraft(visitData.coordination),
        program: getDraft(visitData.program),
        m_and_e: getDraft(visitData.m_and_e),
        recommendation: getDraft(visitData.recommendation),
        attachment: '',
      })
      setTableData(visitData.tableData)
      setRow(tableData.length)
      setCol(tableData.length > 0 ? tableData[0].length : 0)

      setLoading(false)
    }
    fetchMyAPI()
  }, [getAll, project, location])

  return (
    <>
      <MainContainer breadcrums={patientHome}>
        {!loading && (
          <Formik
            initialValues={initValue}
            onSubmit={(values) => submitData(values)}
            validate={(values) => {
              return {}
              // const errors = validateVisit(values)
              // return errors
            }}
          >
            {(formik) => (
              <Form onSubmit={formik.handleSubmit}>
                <Card>
                  <CardBody>
                    <CardTitle className="mb-3" tag="h5">
                      Edit Visit Data
                    </CardTitle>
                    <VisitForm
                      userData={eachData}
                      townships={townships}
                      formik={formik}
                      members={members}
                      onFileChange={(file) => {
                        setAttachment(file)
                      }}
                      row={row}
                      col={col}
                      tableData={tableData}
                      setRow={setRow}
                      setCol={setCol}
                      setTableData={setTableData}
                    />
                  </CardBody>
                  <CardFooter className="d-flex justify-content-end">
                    <Button color="primary" type="submit">
                      Save
                    </Button>
                  </CardFooter>
                </Card>
              </Form>
            )}
          </Formik>
        )}
      </MainContainer>
    </>
  )
}

export default EditVisit
